import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-view-content',
  imports: [],
  templateUrl: './view-content.component.html',
  styleUrl: './view-content.component.scss',
})
export class ViewContentComponent {
  @Input() viewItem = null;
  @Input() viewItemInfo = null;
}
